/* tslint:disable */
/* eslint-disable */
/**
 * Sellsen API
 * Ürün Tarama ve SP-API Entegrasyonu
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import * as runtime from '../runtime';
import { PaginatedResponseWarehouseCreditPackageDTOFromJSON, WarehouseCreditBalanceDTOFromJSON, WarehouseCreditSummaryDTOFromJSON, } from '../models/index';
/**
 *
 */
export class WarehouseCreditControllerApi extends runtime.BaseAPI {
    /**
     */
    async getWarehouseCreditBalanceRaw(initOverrides) {
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        let urlPath = `/api/warehouse-credit/balance`;
        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => WarehouseCreditBalanceDTOFromJSON(jsonValue));
    }
    /**
     */
    async getWarehouseCreditBalance(initOverrides) {
        const response = await this.getWarehouseCreditBalanceRaw(initOverrides);
        return await response.value();
    }
    /**
     */
    async getWarehouseCreditSummaryRaw(initOverrides) {
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        let urlPath = `/api/warehouse-credit/summary`;
        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => WarehouseCreditSummaryDTOFromJSON(jsonValue));
    }
    /**
     */
    async getWarehouseCreditSummary(initOverrides) {
        const response = await this.getWarehouseCreditSummaryRaw(initOverrides);
        return await response.value();
    }
    /**
     */
    async listWarehouseCreditPackagesRaw(requestParameters, initOverrides) {
        const queryParameters = {};
        if (requestParameters['packageStatus'] != null) {
            queryParameters['packageStatus'] = requestParameters['packageStatus'];
        }
        if (requestParameters['marketplace'] != null) {
            queryParameters['marketplace'] = requestParameters['marketplace'];
        }
        if (requestParameters['search'] != null) {
            queryParameters['search'] = requestParameters['search'];
        }
        if (requestParameters['page'] != null) {
            queryParameters['page'] = requestParameters['page'];
        }
        if (requestParameters['size'] != null) {
            queryParameters['size'] = requestParameters['size'];
        }
        if (requestParameters['sort'] != null) {
            queryParameters['sort'] = requestParameters['sort'];
        }
        const headerParameters = {};
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        let urlPath = `/api/warehouse-credit/packages`;
        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => PaginatedResponseWarehouseCreditPackageDTOFromJSON(jsonValue));
    }
    /**
     */
    async listWarehouseCreditPackages(requestParameters = {}, initOverrides) {
        const response = await this.listWarehouseCreditPackagesRaw(requestParameters, initOverrides);
        return await response.value();
    }
}
/**
 * @export
 */
export const ListWarehouseCreditPackagesPackageStatusEnum = {
    NotPurchased: 'NOT_PURCHASED',
    SubmittedToWh: 'SUBMITTED_TO_WH',
    GoingToWh: 'GOING_TO_WH',
    AtWh: 'AT_WH',
    AtWhPaymentPending: 'AT_WH_PAYMENT_PENDING',
    AtWhReturnLabelPending: 'AT_WH_RETURN_LABEL_PENDING',
    Returned: 'RETURNED',
    Shipped: 'SHIPPED',
    Delivered: 'DELIVERED',
    Disposed: 'DISPOSED'
};
/**
 * @export
 */
export const ListWarehouseCreditPackagesMarketplaceEnum = {
    UnitedStates: 'UNITED_STATES',
    Brazil: 'BRAZIL',
    Canada: 'CANADA',
    Mexico: 'MEXICO',
    Australia: 'AUSTRALIA',
    Japan: 'JAPAN',
    India: 'INDIA',
    Singapore: 'SINGAPORE',
    Germany: 'GERMANY',
    Spain: 'SPAIN',
    France: 'FRANCE',
    Italy: 'ITALY',
    Netherlands: 'NETHERLANDS',
    Belgium: 'BELGIUM',
    Poland: 'POLAND',
    Sweden: 'SWEDEN',
    UnitedKingdom: 'UNITED_KINGDOM',
    Ireland: 'IRELAND',
    UnitedArabEmirates: 'UNITED_ARAB_EMIRATES',
    Egypt: 'EGYPT',
    SaudiArabia: 'SAUDI_ARABIA',
    All: 'ALL'
};
